export const UPDATE_CITY = "UPDATE_CITY";
